import React, { useState } from "react";
import "./Post.css";
import { Avatar } from "@material-ui/core";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import NearMeIcon from "@material-ui/icons/NearMe";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import { ExpandMoreOutlined } from "@material-ui/icons";
import HTML2React from 'html2react'

function Post({ profilePic, image, username, timestamp, message }) {
  const [like, setLike] = useState(false);

  const hashtag = (text) => {
    var repl = text.replace(/#(\w+)/g, '<span class="post__hashtag">#$1</span>');
    return repl;
}

  return (
    <div className="post">
      <div className="post__top">
        <Avatar src={profilePic} className="post__avatar" />
        <div className="post__topInfo">
          <h3>{username}</h3>
          <p>{new Date(timestamp?.toDate()).toUTCString()}</p>
        </div>
      </div>
      <div className="post__bottom">
        <p>{HTML2React(hashtag(message))}</p>
      </div>
      <div className="post__image">
        <img src={image} alt="" />
      </div>

      {like && (
        <div className="post__reactions">
          <Avatar className="post__likeAvatar">
            <ThumbUpIcon />
          </Avatar>
          <span>1</span>
        </div>
      )}
      <div className="post__options">
        <div
          className={`post__option ${like && "post__option--blue"}`}
          onClick={() => setLike(!like)}
        >
          <ThumbUpIcon />
          <p>Like</p>
        </div>
        <div className="post__option">
          <ChatBubbleOutlineIcon />
          <p>Comment</p>
        </div>
        <div className="post__option">
          <NearMeIcon />
          <p>Share</p>
        </div>
        <div className="post__option">
          <AccountCircleIcon />
          <ExpandMoreOutlined />
        </div>
      </div>
    </div>
  );
}

export default Post;
